import React from 'react';
import AdressAutocomplete from './AddressAutocomplete';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Button from '@material-ui/core/Button';
import ReactGA from 'react-ga';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    right: {
        paddingLeft: "1rem",
    },
    start: {
        
    },
    element: {
        marginBottom: "1rem",
        marginTop: "1rem",

    },
    container: {
        marginLeft: 'auto',
        textAlign: 'center',
        marginRight: 'auto',
        marginTop: "2rem",
        width: "400px",
        maxWidth: "100%"
    }
  }));

const Address = ({active, next, info, state, change}) => {
    const [value, setValue] = React.useState(info && info.front && info.front.location ? info.front.location.address : '');

    React.useEffect(() => {
        change({...state, location: {...state.location, address: value}})
        
        ReactGA.event({
            category: 'Calc',
            action: 'Address'
          });

    }, [value])
    const classes = useStyles();
    return <Container><Grid container spacing={3} className={classes.container}>
    <Grid item xs={12}>
            <Typography variant="h3" className={classes.element} >Var bor du?</Typography>
            <Typography variant="subtitle1"  className={classes.element}>Välj en plats för dina nya solpaneler</Typography>
    </Grid>

    <Grid item xs={12}>
        <AdressAutocomplete setValue={setValue} value={value} className={classes.element}/>
        <Button disabled={!(value?.length > 3)} color="primary" onClick={event => next()} fullWidth size="large" variant="outlined" className={classes.element}>Fortsätt</Button>
    </Grid>

</Grid></Container>
};

export default Address;